import { useState, useEffect, useRef } from 'react';
import { Tooltip, Chip } from '@mui/material';
import { getStatusColor, getChipTextColor } from '../../../utils/utilFunctions';

const StatusTooltip = ({ cellValues }) => {
	const [isOverflowing, setIsOverflowing] = useState(false);
	const cardRowRef = useRef(null);
	useEffect(() => {
		if (cardRowRef.current) {
			setIsOverflowing(cardRowRef.current.scrollWidth < 130);
		}
	}, [cellValues]);

	return (
		<Tooltip arrow placement="top" title={isOverflowing ? `${cellValues?.formattedValue}` : ''}>
			<Chip
				ref={cardRowRef}
				data-testid={`${cellValues?.field}-${cellValues?.id}`}
				label={cellValues?.formattedValue}
				sx={{
					backgroundColor: getStatusColor(cellValues?.formattedValue),
					color: getChipTextColor(cellValues?.formattedValue)
				}}
				size="small"
			/>
		</Tooltip>
	);
};

export default StatusTooltip;
